<header class="page-head" data-testid="broadcasts-section">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-bullhorn"></i></span>
    <div>
      <h1 class="page-head__title">SMS Massivo</h1>
      <p class="page-head__subtitle">
        Envios de SMS para uma lista ou para números colados, agora ou agendados. Cada envio mostra quantos leads,
        quantos saíram e os cliques do link.
      </p>
    </div>
  </div>
  <div class="page-head__actions">
    <a
      class="sf-btn sf-btn--secondary sf-btn--icon-right"
      *ngIf="user.validated && allowsBroadcast(funds)"
      (click)="toggleStats()"
    >
      Ver estatísticas <i class="fa fa-info-circle"></i>
    </a>

    <a
      [routerLink]="['/broadcasts/new']"
      class="sf-btn sf-btn--primary sf-btn--icon-right"
      *ngIf="user.validated && allowsBroadcast(funds) && user.massive_sms_enabled"
      data-testid="btn-new-broadcast"
    >
      Criar envio em massa <i class="fa fa-paper-plane-o"></i>
    </a>
  </div>
</header>

<!-- Avisos de saldo (o que a conta tem para o envio em massa: `broadcastFunds`). -->
<div class="notice notice--danger" *ngIf="funds === 'no-wallet-balance'" data-testid="funds-no-wallet-balance">
  <i class="fa fa-exclamation-triangle"></i>
  <div class="notice__body">
    Você não possui saldo na carteira. Adicione saldo para realizar seu envio em massa.
  </div>
  <a routerLink="/wallet" class="sf-btn sf-btn--primary sf-btn--sm"><i class="fa fa-plus-circle"></i> Adicionar saldo</a>
</div>

<div class="notice notice--danger" *ngIf="funds === 'no-credits'" data-testid="funds-no-credits">
  <i class="fa fa-exclamation-triangle"></i>
  <div class="notice__body">
    Você não possui créditos. Recarregue agora para realizar seu envio em massa.
  </div>
  <a routerLink="/recharges/new" class="sf-btn sf-btn--primary sf-btn--sm"><i class="fa fa-plus-circle"></i> Recarregar</a>
</div>

<!-- O billing não respondeu e o pacote está zerado: não dá para saber se o canal sai da carteira. -->
<div class="notice notice--success" *ngIf="funds === 'unknown'" data-testid="funds-unknown">
  <i class="fa fa-info-circle"></i>
  <div class="notice__body">
    Não deu para confirmar agora de onde sai a cobrança deste envio. <strong>O saldo é conferido quando o envio é criado.</strong>
  </div>
</div>

<form (submit)="pageChanged(page)">
  <div class="filter-bar">
    <div class="search-wrap grow">
      <i class="fa fa-search"></i>
      <input
        type="text"
        name="text"
        [(ngModel)]="text"
        class="form-control"
        placeholder="Pesquisar pelo nome do envio massivo"
        data-testid="input-broadcast-name"
      />
      <button type="submit" class="search-go" (click)="pageChanged(page)" data-testid="btn-search" aria-label="Pesquisar">
        <i class="fa fa-search"></i>
      </button>
    </div>

    <div class="m8v-period" title="Período (data inicial e final)">
      <i class="fa fa-calendar-o ic"></i>
      <input type="date" [(ngModel)]="startedMonth" name="startedMonth" data-testid="input-started-month" />
      <span class="sep">até</span>
      <input type="date" [(ngModel)]="endedMonth" name="endedMonth" data-testid="input-ended-month" />
      <small class="err" *ngIf="startedMonth && endedMonth && startedMonth > endedMonth">Período inválido.</small>
    </div>

    <div class="sort-wrap">
      <select name="orderBy" id="orderBy" class="form-select" [(ngModel)]="orderBy" [value]="orderBy" (change)="orderByChanged()">
        <option value="created_at">Ordenar por data</option>
        <option value="broadcast_status_id">Ordenar por status</option>
        <option value="leads_count">Ordenar por leads</option>
      </select>
      <button
        type="button"
        class="sf-btn sf-btn--secondary sf-btn--icon"
        [title]="invertedOrder ? 'Ordem crescente (inverter)' : 'Ordem decrescente (inverter)'"
        (click)="invertOrder()"
      >
        <i class="fa" [class.fa-sort-amount-asc]="!invertedOrder" [class.fa-sort-amount-desc]="invertedOrder"></i>
      </button>
    </div>
  </div>
</form>

<div class="sf-card" *ngIf="statisticsToggled" [class]="[statisticsClass]" id="broadcasts-stats">
  <h5 class="card-section-title">
    <i class="fa fa-bar-chart"></i> Estatísticas
  </h5>
  <p class="card-section-hint">Selecione um intervalo para visualizar a quantidade total de mensagens de broadcasts emitidas:</p>
  <div class="inline-fields">
    <mat-form-field>
      <input matInput [ngxMatDatetimePicker]="picker1" placeholder="Data inicial" [(ngModel)]="statisticsStartDate" [disabled]="false" />
      <ngx-mat-datepicker-toggle matSuffix [for]="picker1"></ngx-mat-datepicker-toggle>
      <ngx-mat-datetime-picker #picker1 [showSpinners]="true" [showSeconds]="false" [stepHour]="1" [stepMinute]="1" [stepSecond]="1"
        [touchUi]="false" [enableMeridian]="true" [disableMinute]="false" [hideTime]="false">
      </ngx-mat-datetime-picker>
      <small class="field-error" *ngIf="statisticsStartDate && statisticsEndDate && statisticsStartDate > statisticsEndDate">Período inválido.</small>
    </mat-form-field>
    <mat-form-field>
      <input matInput [ngxMatDatetimePicker]="picker2b" placeholder="Data final" [(ngModel)]="statisticsEndDate" [disabled]="false" />
      <ngx-mat-datepicker-toggle matSuffix [for]="picker2b"></ngx-mat-datepicker-toggle>
      <ngx-mat-datetime-picker #picker2b [showSpinners]="true" [showSeconds]="false" [stepHour]="1" [stepMinute]="1" [stepSecond]="1"
        [touchUi]="false" [enableMeridian]="true" [disableMinute]="false" [hideTime]="false">
      </ngx-mat-datetime-picker>
      <small class="field-error" *ngIf="statisticsStartDate && statisticsEndDate && statisticsStartDate > statisticsEndDate">Período inválido.</small>
    </mat-form-field>
    <div class="stats-toggle">
      <app-switcher [(checked)]="showBroadcastsStatistics"></app-switcher>
      <span class="stats-toggle__label" (click)="showBroadcastsStatistics = !showBroadcastsStatistics">Ocultar broadcasts fora deste período abaixo</span>
    </div>
    <button class="sf-btn sf-btn--primary stats-confirm" (click)="getTotal()"><i class="fa fa-check-circle"></i> Confirmar</button>
  </div>
  <div class="stats-total" [class]="statisticsTotalClass">
    <span class="lbl-sm">Total</span>
    <span class="stats-total__value">{{ statisticsTotal | numberFormat }}</span>
    <span class="field-hint">mensagens emitidas no período</span>
  </div>
</div>

<app-skeleton *ngIf="loading" variant="table-row" [count]="8" [columns]="5"
  label="Carregando os broadcasts" data-testid="broadcasts-loading"></app-skeleton>

<div *ngIf="!loading && result?.data.length > 0; else notFound" data-testid="broadcasts-list">
  <div
    *ngFor="let broadcast of result.data"
    class="row-card"
    [class]="'tone-' + statusTone(broadcast)"
    [class.is-inactive]="isCancelled(broadcast)"
    data-testid="broadcast-item"
  >
    <span class="row-avatar">
      <i class="fa" [class.fa-list-ul]="broadcast.lead_list_id" [class.fa-hashtag]="!broadcast.lead_list_id"></i>
    </span>

    <div class="info">
      <div class="name">
        <a class="name-link" [routerLink]="['/broadcasts/view', broadcast.id]">{{ broadcast.name }}</a>
        <span class="status-pill status-pill--sm" [ngClass]="'status-pill--' + statusTone(broadcast)">
          {{ broadcast.broadcast_status_id | broadcastStatus }}
        </span>
      </div>

      <div class="meta-line">
        <span class="bind-chip" [class.bind-chip--numbers]="!broadcast.lead_list_id">
          <i class="fa" [class.fa-list-ul]="broadcast.lead_list_id" [class.fa-hashtag]="!broadcast.lead_list_id"></i>
          {{ broadcast.lead_list_id ? "Para lista" : "Para números" }}
        </span>
        <span class="meta-chip" title="Data envio"><i class="fa fa-calendar"></i> {{ broadcast.scheduled_date | date : "dd/MM/yyyy, H:mm" }}</span>
        <span class="meta-chip" *ngIf="broadcast.short_url" title="Com link encurtado"><i class="fa fa-link"></i> link</span>
        <span class="meta-chip reason" *ngIf="isCancelled(broadcast) && broadcast.reason" title="Motivo do cancelamento">
          <i class="fa fa-info-circle"></i> {{ broadcast.reason }}
        </span>
      </div>
    </div>

    <div class="stats">
      <div class="stat"><b>{{ broadcast.leads_count }}</b><span>Leads totais</span></div>
      <div class="stat" *ngIf="administrator"><b>{{ broadcast.invalid_leads_count }}</b><span>Higienizados</span></div>
      <div class="stat" data-testid="status"><b>{{ broadcast.total_sent }}</b><span>Total de envios</span></div>
      <div class="stat" *ngIf="broadcast.short_url"><b>{{ broadcast.clicks || 0 }}</b><span>Total clicks</span></div>
    </div>

    <div class="icon-group">
      <a class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm" title="Ver acompanhamento" [routerLink]="['/broadcasts/view', broadcast.id]">
        <i class="fa fa-eye"></i>
      </a>
      <a
        class="sf-btn sf-btn--primary sf-btn--icon sf-btn--sm"
        title="Editar"
        [routerLink]="['/broadcasts/', broadcast.id]"
        *ngIf="canEdit(broadcast)"
      >
        <i class="fa fa-pencil"></i>
      </a>
      <button
        type="button"
        class="sf-btn sf-btn--danger-ghost sf-btn--sm"
        (click)="confirmCancel(broadcast)"
        *ngIf="canCancel(broadcast)"
      >
        <i class="fa fa-ban"></i> Cancelar
      </button>

      <span class="menu-dots" [class.open]="openMenuId === broadcast.id" *ngIf="administrator">
        <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" title="Mais ações" (click)="toggleMenu(broadcast.id, $event)">
          <i class="fa fa-ellipsis-v"></i>
        </button>
        <div class="dd" *ngIf="openMenuId === broadcast.id" (click)="$event.stopPropagation()">
          <div class="dd-lbl">Administrador</div>
          <button *ngIf="isSent(broadcast) || isCancelled(broadcast) || isSending(broadcast)" (click)="new(modalBroadcast, broadcast.id); openMenuId = null">
            <i class="fa fa-paper-plane-o"></i> Reenviar Broadcast
          </button>
          <button *ngIf="isSent(broadcast) || isCancelled(broadcast) || isSending(broadcast)" (click)="resendModal(modalResend, broadcast); openMenuId = null">
            <i class="fa fa-align-justify"></i> Logs de reenvio
          </button>
          <div class="dd-sep"></div>
          <button class="danger" *ngIf="isHiddenButton(broadcast)" (click)="confirmDelete(broadcast); openMenuId = null" data-testid="btn-delete-broadcast">
            <i class="fa fa-trash"></i> Excluir broadcast
          </button>
        </div>
      </span>
    </div>
  </div>
</div>

<ng-template #modalBroadcast let-modal>
  <div>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Reenviar Broadcast</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('CLOSE')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <form [formGroup]="broadcastForm" (subimit)="resend(modal)">
        <div class="form-group">
          <label for="broadcast_provider_account_id">Conta Broadcast</label>
          <select class="form-control" id="broadcast_provider_account_id" formControlName="providerAccountId">
            <option *ngFor="let providerAccount of providerAccounts" [value]="providerAccount.id">{{ providerAccount.name }}</option>
          </select>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="sf-btn sf-btn--primary" (click)="acceptModal(modal, modalAccept)">
        Reenviar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modalAccept let-modal>
  <div>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Reenviar Broadcast</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('CLOSE')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      Você tem certeza que deseja reenviar o broadcast na saida selecionada?
    </div>
    <div class="modal-footer">
      <button type="button" class="sf-btn sf-btn--secondary me-1" (click)="modal.dismiss('CLOSE')">
        Cancelar
      </button>
      <button type="button" class="sf-btn sf-btn--primary" (click)="resend(modal)">
        Sim
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modalResend let-modal>
  <div>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Visualizar logs de reenvio</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('CLOSE')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col-md-2"><label>Data</label></div>
        <div class="col-md-2"><label>Enviado por</label></div>
        <div class="col-md-2"><label>Conta Broadcast</label></div>
        <div class="col-md-6"><label>Log</label></div>
      </div>
      <div class="row" *ngFor="let log of broadcastResendLog">
        <div class="col-md-2"><p>{{ log.resend_date | date : "dd/MM/yyyy, H:mm" }}</p></div>
        <div class="col-md-2 text-break"><p>{{ log.resend_by_email }}</p></div>
        <div class="col-md-2"><p>[{{ log.provider_name }}] {{ log.provider_account_name }}</p></div>
        <div class="col-md-6"><p>{{ log.log }}</p></div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="sf-btn sf-btn--secondary me-1" (click)="modal.dismiss('CLOSE')">
        Fechar
      </button>
    </div>
  </div>
</ng-template>

<app-pagination
  *ngIf="!loading && result"
  [currentPage]="result.current_page"
  [itemsPerPage]="result.per_page"
  [totalItems]="result.total"
  (pageChanged)="pageChanged($event)"
></app-pagination>

<ng-template #notFound>
  <div class="sf-card empty" *ngIf="!loading && user.validated">
    <i class="fa fa-paper-plane-o"></i>
    <p data-testid="no-broadcasts">Nenhum envio em massa encontrado!</p>
  </div>
</ng-template>
